module.exports = __webpack_public_path__ + "img/chijieban8.36ef2839.jpg";